import { ReactNode } from "react";

import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "./alert-dialog";
import { Button } from "./button";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: ReactNode;
  confirmLabel?: string;
  // 지우기처럼 되돌릴 수 없는 일이면 빨간 버튼.
  destructive?: boolean;
  onConfirm: () => void;
  testId?: string;
}

/** window.confirm 대신 쓰는 확인 창 — 열림은 부르는 쪽이 들고(open·onOpenChange), 확인을 누르면 닫고 onConfirm 을 부른다 · 제목은 「이 일지를 지울까요?」 처럼 물음, description 은 결과 한 줄(「지운 일지는 되돌릴 수 없습니다.」) · confirmLabel 은 「확인」 대신 동사(「지우기」·「서식 바꾸기」) · 되돌릴 수 없으면 destructive(빨간 버튼) · 취소 단추는 「취소」 고정 · 변형은 Button variant 로(className 을 지어 붙이면 디자인 린트가 못 읽는다) · 단추 배치를 바꿔야 하면 AlertDialog 를 직접 조립한다. */
const ConfirmDialog = ({ open, onOpenChange, title, description, confirmLabel = "확인", destructive = false, onConfirm, testId }: Props) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent data-testid={testId}>
      <AlertDialogHeader>
        <AlertDialogTitle>{title}</AlertDialogTitle>
        {description && <AlertDialogDescription>{description}</AlertDialogDescription>}
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>취소</AlertDialogCancel>
        <Button
          variant={destructive ? "destructive" : "primary"}
          data-testid={testId ? `${testId}-confirm` : undefined}
          onClick={() => {
            onOpenChange(false);
            onConfirm();
          }}>
          {confirmLabel}
        </Button>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export default ConfirmDialog;
